import { useQuery } from "@tanstack/react-query";
import { payerService } from "../../services/payer.service";

export const usePayers = () => {
	return useQuery({
		queryKey: ["payers"],
		queryFn: payerService.findAll,
	});
};

export const useActivePayers = () => {
	return useQuery({
		queryKey: ["payers", "active"],
		queryFn: async () => {
			const payers = await payerService.findAll();
			return payers.filter((payer) => payer.status === "ACTIVE");
		},
	});
};
